import { getMicrosEnv } from '@atlassian/temp-shared';

export const getIdentityUrl = () => {
  switch (getMicrosEnv()) {
    case 'stg-east':
      return 'https://id.stg.internal.atlassian.com';
    case 'prod-east':
      return 'https://id.atlassian.com';
    case 'stg-fedm-east':
      return 'https://id.stg.atlassian-us-gov-mod.com';
    case 'prod-fedm-east':
      return 'https://id.atlassian-us-gov-mod.com';
    default:
      return 'https://id.stg.internal.atlassian.com';
  }
};

export const getWACUrl = (): string => {
  switch (getMicrosEnv()) {
    case 'prod-east':
      return 'https://atlassian.com';
    case 'stg-east':
      return 'https://wac.stg.internal.atlassian.com';
    default:
      return 'https://wac.stg.internal.atlassian.com';
  }
};

export const handlePPCLogout = () => {
  window.location.href = `${getIdentityUrl()}/logout?continue=${window.location.protocol}//${window.location.host}`;
};

export const handlePPCUserProfileClick = (email: string) => {
  const identityUrl = getIdentityUrl();
  window.open(`${identityUrl}/login?login_hint=${email}&prompt=none&continue=${identityUrl}/manage-profile`, '_blank');
};

export const handlePPCLogin = () => {
  if (process.env.NODE_ENV !== 'development') {
    window.location.href = `${getIdentityUrl()}/login?continue=${window.location.href}`;
  }
};

export const handlePPCSwitchAccountClick = () => {
  window.location.href = `${getIdentityUrl()}/login?prompt=select_account&continue=${window.location.protocol}//${
    window.location.host
  }`;
};
